import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import { Button, FormControl, InputLabel, MenuItem, Select, Stack, SxProps, Theme, Typography } from '@mui/material';
import { useState } from 'react';
import useSextforceAutoRepostColors from '../../hooks/useSextforceAutoRepostColors';
import SextforceAutoRepostColorsDialog from '../services/sextforce/autoRepost/SextforceAutoRepostColorsDialog';

type Props = {
    colorId?: string;
    setColorId: (colorId: string | undefined) => void;
    allowEdit?: boolean;
    noneName?: string;
    size?: 'small' | 'medium';
    sx?: SxProps<Theme>;
    selectSx?: SxProps<Theme>;
    buttonSx?: SxProps<Theme>;
};

const SextforceColorSelector = ({ colorId, setColorId, size, noneName = 'None', allowEdit = true, sx, selectSx, buttonSx }: Props) => {
    const { data: sextforceAutoRepostColors, isLoading: isSextforceAutoRepostColorsLoading } = useSextforceAutoRepostColors();

    const [showColorsDialog, setShowColorsDialog] = useState(false);

    return (
        <Stack direction="row" spacing={1} alignItems={'center'} justifyContent={'space-between'} sx={sx}>
            <FormControl fullWidth size={size}>
                <InputLabel id="color-label">Color</InputLabel>
                <Select
                    labelId="color-label"
                    label="Color"
                    id="color"
                    size={size}
                    value={colorId || 'none'}
                    onChange={e => setColorId(e.target.value === 'none' ? undefined : (e.target.value as string))}
                    sx={selectSx}
                >
                    <MenuItem value="none">
                        <Stack direction="row" spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                            <CircleOutlinedIcon
                                color="disabled"
                                sx={{
                                    diaplay: 'inline-block',
                                    fontSize: 20,
                                }}
                            />
                            <Typography variant="body1" color={'text.primary'}>
                                {noneName}
                            </Typography>
                        </Stack>
                    </MenuItem>
                    {isSextforceAutoRepostColorsLoading && <MenuItem disabled>Loading...</MenuItem>}
                    {!isSextforceAutoRepostColorsLoading &&
                        sextforceAutoRepostColors &&
                        sextforceAutoRepostColors.map(color => (
                            <MenuItem key={color._id} value={color._id}>
                                <Stack direction="row" spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                                    <CircleIcon
                                        sx={{
                                            diaplay: 'inline-block',
                                            color: color.color,
                                            fontSize: 20,
                                        }}
                                    />
                                    <Typography variant="body1" color={'text.primary'}>
                                        {color.name}
                                    </Typography>
                                </Stack>
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
            {allowEdit && (
                <Button
                    variant="contained"
                    color="info"
                    size={size === 'small' ? 'medium' : 'large'}
                    onClick={() => {
                        setShowColorsDialog(true);
                    }}
                    sx={buttonSx}
                >
                    Edit...
                </Button>
            )}
            <SextforceAutoRepostColorsDialog open={showColorsDialog} onClose={() => setShowColorsDialog(false)} />
        </Stack>
    );
};

export default SextforceColorSelector;
